<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <KTCodePreview v-bind:title="'Logs de Usuários'">
          <template v-slot:preview>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="filtro"
                  label="Filtro de Pesquisa"
                  hint="Filtro mínimo: 4 caracteres"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-btn
                  @click="filtrar()"
                  color="primary"
                  :disabled="isDisabledFiltrar || loading"
                  large
                  class="ml-2"
                  >Filtrar</v-btn
                >              
              </v-col>
              <v-col cols="3">
                <v-btn
                  @click="limparFiltro()"
                  color="primary"
                  :disabled="loading"
                  large
                  class="ml-2"
                  >Limpar filtro</v-btn
                >              
              </v-col>
            </v-row>
           
              <v-row class="pl-3">
                 <v-col cols="6">
                  </v-col>
                  <v-col cols="3">
                  </v-col>
                  <v-col cols="3">
                    <download-excel
                  :data="configExportar.logsExportar"
                  :name="configExportar.nomeArquivo"
                >
                  <v-btn
                    title="Download"
                    color="success"
                    small
                    :disabled="logs.length === 0"
                  >
                    <v-icon class="mr-4" small>fa fa-download</v-icon>
                    Exportar em .XLS
                  </v-btn>
                </download-excel>
                  </v-col>              
              </v-row>
              <v-row >
              </v-row>
             <v-divider></v-divider>
            <v-row v-if="!loading">
              <v-col cols="6" offset="6">
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Pesquisa"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
            <v-data-table
              v-if="!loading"
              :headers="headers"
              :items="logs"
              :search="search"
              :items-per-page.sync="itemsPerPage"
              :page.sync="page"
            >
              <template v-slot:item="{ item, index }">
                <tr>
                  <td>
                    <v-avatar color="primary" size="36" class="mr-5">
                      <img
                        :src="item.usuario.caminhoVisualizacao"
                        :alt="item.usuario.nome"
                        v-if="item.usuario.caminhoVisualizacao.length > 0"
                      />
                      <span class="white--text headline" v-else>
                        {{ iniciais(index) }}</span
                      ></v-avatar
                    >
                    {{ item.usuario.nome }}
                  </td>
                  <td>{{ obterNomePerfil(item.usuario.perfilID) }}</td>
                  <td v-if="item.metodo === 'POST'">
                    <v-icon color="success" small>fas fa-plus</v-icon>
                  </td>
                  <td
                    v-else-if="
                      item.metodo === 'PUT' && item.urlAcionada !== 'Inactivate'
                    "
                  >
                    <v-icon color="warning" small>fas fa-edit</v-icon>
                  </td>
                  <td
                    v-else-if="
                      (item.metodo === 'PUT' &&
                        item.urlAcionada === 'Inactivate') ||
                      item.metodo === 'DELETE'
                    "
                  >
                    <v-icon color="error" small>fas fa-trash</v-icon>
                  </td>
                  <td v-else>{{ item.metodo }}</td>
                  <td>{{ formatarCamelCase(item.controle) }}</td>
                  <td>{{ formatarUrlAcionada(item.urlAcionada) }}</td>
                  <td>
                    {{
                      item.registroAfetado === null ? "" : item.registroAfetado
                    }}
                  </td>
                  <td>{{ formatarData(item.dataLog) }}</td>
                  <td
                    v-if="
                      item.registroAntigo != null || item.registroNovo != null
                    "
                  >
                    <v-btn
                      color="primary"
                      fab
                      x-small
                      dark
                      @click="
                        exibirLogs(
                          item.registroAntigo,
                          item.registroNovo,
                          item.urlAcionada,
                          item.controle
                        )
                      "
                      ><v-icon>mdi-eye</v-icon></v-btn
                    >
                  </td>
                  <td v-else></td>
                </tr>
              </template>
            </v-data-table>
            <v-progress-linear
              v-else
              indeterminate
              size="100"
              color="primary"
            ></v-progress-linear>
            <v-divider></v-divider>
          </template>
        </KTCodePreview>
      </div>
    </div>
    <HistoricoLog
      :registroAntigo="registroAntigo"
      :urlAcionada="urlAcionada"
      :registroHeaderAntigo="registroHeaderAntigo"
      :registroUrlAntigo="registroUrlAntigo"
      :registroUrlNovo="registroUrlNovo"
      :registroNovo="registroNovo"
      :registroHeaderNovo="registroHeaderNovo"
      :dialog="showDialog"
      :controller="controller"
      @sync-dialog="closeDialogSync"
    ></HistoricoLog>
  </div>
</template>

<script>
import KTCodePreview from "@/views/partials/content/CodePreview.vue";
import ApiService from "@/common/services/http/api.service";
import SweetAlert from "@/common/services/sweetalert.service";
import moment from "moment";
import HistoricoLog from "@/views/components/HistoricoLog.vue";
import Permissoes from "@/common/services/permissoes/permissoes.js";
import Modulo from "@/common/services/permissoes/modulos.js";
import PermissoesService from "@/common/services/permissoes/permissoes.service.js";

export default {
  name: "logusuario",
  data() {
    return {
      filtro: "",
      page: 1,
      itemsPerPage: 10,
      logs: [],
      search: "",
      headers: [
        { text: "Usuário", value: "usuario.nome", sortable: false },
        { text: "Perfil", value: "usuario.perfilNome", sortable: false },
        { text: "Método", value: "metodo", sortable: false },
        { text: "Controle", value: "controle", sortable: false },
        { text: "URL Acionada", value: "urlAcionada", sortable: false },
        { text: "Registro Afetado", value: "registroAfetado", sortable: false },
        { text: "Data Log", value: "dataLog", sortable: true },
        { text: "", value: "" },
      ],
      sortBy: "dataLog",
      cliente: {},
      perfis: [],
      registroAntigo: [],
      orderByDesc: true,
      urlAcionada: "",
      controller: "",
      loading: false,
      registroHeaderAntigo: null,
      registroUrlAntigo: "Registro(s) Antigo(s)",
      registroNovo: [],
      pagination: {},
      registroHeaderNovo: null,
      registroUrlNovo: "Registro(s) Novo(s)",
      showDialog: false,
      deleteUrls: ["Delete", "AtualizarAprovadores"],
      inativosUrls: ["Inactivate", "Inativar"],
      dicionario: {
        Alterar: "Alterar",
        CriarPendencia: "Criar Pendência",
        Ativar: "Ativar",
        Update: "Alterar",
        Delete: "Remover",
        Create: "Incluir",
        Incluir: "Incluir",
        Validar: "Validar",
        Atualizar: "Atualizar",
        Inactivate: "Inativar",
        VincularTemplateDocumento: "Vincular Template Documento",
        Inativar: "Inativar",
        AlterarSenha: "Alterar Senha",
        UpdatePadraoEmpresa: "Atualizar",
        AtualizarAprovadores: "Atualizar Aprovadores",
      },
      configExportar: {
        logsExportar: [],
        nomeArquivo: "",
      },
      configExportarLogs: {
        logsExportar: [],
        nomeArquivo: "",
      },
    };
  },
  components: {
    KTCodePreview,
    HistoricoLog,
  },
  watch: {
    orderByDesc: {
      async handler(orderByDesc) {
        await this.listaLog(orderByDesc, this.page);
      },
    },
  },
  computed: {
    isDisabledFiltrar() {
      return this.filtro.length < 4;
    },
  },
  methods: {
    async listaLog(orderByDesc, page = 1, search = null) {
      this.loading = true;
      this.page = page;
      this.search = search;
      this.orderByDesc = typeof orderByDesc == "undefined" ? null : orderByDesc;
      const { data: result } = await ApiService.get(
        "logusuario/getbyclienteid/" + this.cliente.id
      );
      if (result.success) {
        this.page = 1;
        this.itemsPerPage = 10;
        this.logs = result.data;
        this.loading = false;
      } else {
        this.loading = false;
        SweetAlert.sweetAlertError(result.errors);
      }
      this.listaExcelLogs();
    },

    async listaLogFiltrado(orderByDesc, page = 1, search = null) {
      this.loading = true;
      this.page = page;
      this.search = search;
      this.orderByDesc = typeof orderByDesc == "undefined" ? null : orderByDesc;
      const { data: result } = await ApiService.get(
        "logusuario/getbyclienteid/" + this.cliente.id + '/' + this.filtro
      );
      if (result.success) {
        this.page = 1;
        this.itemsPerPage = 10;
        this.logs = result.data;
        this.loading = false;
      } else {
        this.loading = false;
        SweetAlert.sweetAlertError(result.errors);
      }
      this.listaExcelLogs();
    },

    listaExcelLogs() {
      const logsExportar = this.logs.map((p) => {
        return {
          "Usuário": p.usuario.nome,
          "Metodo": p.metodo,
          "Controle": p.controle,
          "Url Acionada": p.urlAcionada,
          "Registro Afetado": p.registroAfetado,
          "Data Log": this.formatarData(p.dataLog),
        };
      });

      this.configExportar.logsExportar = logsExportar;
      this.configExportar.nomeArquivo = `Logs-${Date.now()}`;
    },

    closeDialogSync(obj) {
      this.showDialog = obj.dialog;
      this.registroAntigo = [];
      this.registroNovo = [];
      this.urlAcionada = "";
    },

    limparFiltro() {
      this.listaLog(true, 1);
    },

    filtrar() {
      this.listaLogFiltrado(true, 1);
    },

    exibirLogs(registroAntigo, registroNovo, urlAcionada, controller) {
      let antigo = JSON.parse(registroAntigo);
      let novo = JSON.parse(registroNovo);

      if (antigo) {
        if (typeof antigo.length == "undefined") {
          Object.keys(antigo).forEach((key) => {
            if (typeof antigo[key] == "boolean") {
              antigo[key] = antigo[key] ? "Sim" : "Não";
            }
          });

          this.registroAntigo.push(antigo);
        } else this.registroAntigo = antigo;

        this.registroHeaderAntigo = this.gerarHeader(this.registroAntigo[0]);
      }

      if (novo) {
        if (typeof novo.length == "undefined") {
          Object.keys(novo).forEach((key) => {
            if (typeof novo[key] == "boolean") {
              novo[key] = novo[key] ? "Sim" : "Não";
            }
          });
          this.registroNovo.push(novo);
        } else this.registroNovo = novo;

        this.registroHeaderNovo = this.gerarHeader(this.registroNovo[0]);
      }

      if (["Delete", "AtualizarAprovadores"].includes(urlAcionada)) {
        this.registroUrlAntigo = "Registro(s) Removido(s)";
        this.registroUrlNovo = "Registro(s) Adicionado(s)";
      } else if (urlAcionada == "Create") {
        this.registroUrlAntigo = "Registro(s) Removido(s)";
        this.registroUrlNovo = "Registro(s) Criado(s)";
      } else if (["Inactivate", "Inativar"].includes(urlAcionada)) {
        this.registroUrlAntigo = "Registro(s) Inativado(s)";
        this.registroUrlNovo = "Registro(s) Inativado(s)";
      } else if (["Ativar"].includes(urlAcionada)) {
        this.registroUrlAntigo = "Registro(s) Ativado(s)";
        this.registroUrlNovo = "Registro(s) Ativado(s)";
      } else {
        this.registroUrlAntigo = "Registro(s) Antigo(s)";
        this.registroUrlNovo = "Registro(s) Novo(s)";
      }

      this.urlAcionada = this.formatarUrlAcionada(urlAcionada);
      this.controller = this.formatarCamelCase(controller);
      this.showDialog = true;
    },

    iniciais(index) {
      return (
        this.logs[index].usuario.nome.split(" ")[0].substr(0, 1) +
        this.logs[index].usuario.nome
          .split(" ")
          [this.logs[index].usuario.nome.split(" ").length - 1].substr(0, 1)
      );
    },

    formatarUrlAcionada(urlAcionada) {
      let url = this.dicionario[urlAcionada];

      return url == undefined ? urlAcionada : url;
    },

    async listarPerfis() {
      this.processando = true;
      try {
        const { data: result } = await ApiService.get(
          `perfil/listar/cliente/${this.cliente.id}`,
          "",
          {
            listarInativos: true,
          }
        );
        if (result.success) this.perfis = result.data;
      } catch (error) {
        this.perfis = [];
      }
    },

    obterNomePerfil(id) {
      let perfil = this.perfis.find((x) => x.id == id)?.nome;

      return perfil || "Administrador";
    },

    formatarCamelCase(text) {
      let result = text.replace(/([A-Z])/g, " $1");
      return result.charAt(0).toUpperCase() + result.slice(1);
    },

    gerarHeader(item) {
      if (item) {
        let headers = Object.keys(item);
        return headers.map((x) => ({
          text: this.formatarCamelCase(x),
          value: x,
        }));
      }

      return {};
    },

    formatarData(data) {
      let newDate = moment(data);
      return newDate.format("DD/MM/yyyy HH:mm");
    },

    async ordenacaoCustomizada(items, index, isDesc) {
      if (index[0] == "dataLog") {
        await this.listaLog(isDesc[0], this.page);
      } else if (index[0] == "registroAfetado") {
        items.sort((a, b) => {
          if (
            typeof a[index] !== "undefined" ||
            a[index] ||
            typeof b[index] !== "undefined" ||
            b[index]
          ) {
            if (!isDesc[0]) return b[index] - a[index];
            else return a[index] - b[index];
          } else return -1;
        });
      } else {
        items.sort((a, b) => {
          if (typeof a[index] !== "undefined" || !a[index]) {
            if (!isDesc[0]) {
              if (a[index])
                return a[index]
                  .toLowerCase()
                  .localeCompare(b[index].toLowerCase());
              else return -1;
            } else {
              if (a[index])
                return b[index]
                  .toLowerCase()
                  .localeCompare(a[index].toLowerCase());
              else return -1;
            }
          }
        });
      }
      return items;
    },
  },

  async mounted() {
    this.cliente = JSON.parse(window.localStorage.getItem("cliente"));
    this.listaLog(true, 1);
    await this.listarPerfis();
  },
  created() {
    if (!PermissoesService.verificarAcesso(Modulo.Log, Permissoes.Visualizar)) {
      SweetAlert.sweetAlertError([
        "Você não tem permissão para acessar essa parte do sistema",
      ]);
      this.$router.push({ name: "index" });
    }
  },
};
</script>
